import * as Icons from './icons';
import * as Illustrations from './illustrations';
import * as Logos from './logos';
export { SvgIcon } from './SvgIcon';
export { Icons, Illustrations, Logos };
//# sourceMappingURL=index.js.map